import React from 'react';
import { Link } from 'react-router-dom';
import ctaImage from '../../assets/Capturex.PNG';

const getTimeAwareHeadline = () => {
  const hour = new Date().getHours();
  if (hour >= 8 && hour < 12) return 'Book Your Perfect Lunch';
  if (hour >= 12 && hour < 17) return 'Reserve Your Dinner Table';
  return 'Reserve Your Table Tonight';
};

const scenarios = [
  { icon: '💑', name: 'Date Night' },
  { icon: '🎂', name: 'Birthday' },
  { icon: '💼', name: 'Business Lunch' },
  { icon: '👨‍👩‍👧', name: 'Family' },
  { icon: '🎊', name: 'Corporate' },
];

const ReservationCTA = () => (
  <section className="section-padding" style={{
    background: `linear-gradient(rgba(26, 26, 26, 0.75), rgba(26, 26, 26, 0.85)), url(${ctaImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed'
  }}>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-8 text-center reveal">
          <span className="section-subtitle">Book Your Experience</span>
          <h2 className="text-white mt-3 mb-3" style={{ fontFamily: 'Playfair Display, serif', fontSize: '2.8rem', fontWeight: 600 }}>
            {getTimeAwareHeadline()}
          </h2>
          <div className="gold-divider-center"></div>

          {/* Perfect for scenarios */}
          <div className="scenario-chips my-4">
            {scenarios.map((s, i) => (
              <span key={i} className="scenario-chip">{s.icon} {s.name}</span>
            ))}
          </div>

          <p className="text-white mb-4" style={{ fontSize: '1.05rem', opacity: 0.85, lineHeight: 1.9, maxWidth: '600px', margin: '0 auto 30px' }}>
            Whether it's a romantic dinner, family celebration, or corporate event — we'll make it unforgettable.
          </p>

          {/* Trust micro-copy */}
          <div className="d-flex gap-3 justify-content-center flex-wrap mb-4" style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)' }}>
            <span>✅ No Booking Fees</span>
            <span>✅ Instant Confirmation</span>
            <span>✅ Available Today</span>
          </div>

          <div className="d-flex gap-4 justify-content-center flex-wrap">
            <Link to="/booking" className="btn btn-gold" style={{ padding: '16px 44px', fontSize: '0.9rem' }} data-track="reserve_click">
              Reserve Now
            </Link>
            <a href="tel:+256772206129" className="btn btn-outline-gold" style={{ padding: '16px 44px', fontSize: '0.9rem' }}>
              Call Us
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ReservationCTA;
